import React from 'react';

export const ErrorView = ({ statusCode }: { statusCode: number }) => {
  document.getElementById('loaderDiv')?.remove();

  if (statusCode === 404) {
    return <>This store does not exist.</>;
  }
  if (statusCode === 403) {
    return <>This store is not yet live.</>;
  }

  return null;
};
